import { FaInstagram, FaYoutube, FaEnvelope } from "react-icons/fa";

const Footer = () => {
    return (
        <div className="footer shadow bg-dark d-flex align-items-center">
            <div className="container">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-white-50 small w-100">
                    <span>&copy; {new Date().getFullYear()} Abdução Filmes</span>
                    <div className="d-flex gap-3 mt-1 mt-md-0">
                        <a href="https://instagram.com/abducaofilmes" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                            <FaInstagram size={18} />
                        </a>
                        <a href="https://www.youtube.com/@abducaofilmes" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                            <FaYoutube size={18} />
                        </a>
                        <a href="mailto:abducaofilmes@gmail.com" aria-label="E-mail">
                            <FaEnvelope size={18} />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;
